// Global capture of the PWA install prompt.
//
// Chrome/Edge fire `beforeinstallprompt` once, early in the page's life —
// often before any given component has mounted. We listen at module load
// (imported from index.js) so the event is never missed, stash it, and let
// any component subscribe and trigger the native prompt later.
let deferredPrompt = null;
const listeners = new Set();

function notify() {
  listeners.forEach((fn) => {
    try {
      fn(deferredPrompt);
    } catch {
      /* ignore listener errors */
    }
  });
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });
}

export function getDeferredPrompt() {
  return deferredPrompt;
}

export function clearDeferredPrompt() {
  deferredPrompt = null;
}

// Subscribe to install-availability changes. Returns an unsubscribe fn.
export function onInstallChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
